import axios from 'axios';
import { API_PREFIX } from '@/constants';
import {MomentsStatus} from './constants'
import {AuthContextValue} from "@/contexts/auth";

interface QueryMomentsListParams {
    publishStatus: MomentsStatus;
    auth: AuthContextValue,
}

interface MomentsListResult {
    id: number,
    type: number,
    allUser: boolean,
    basicRule: object,
    sendType: string,
    sendTime: string,
    status: number,
    content: MomentsInfo[],
}

interface MomentsInfo {
    type: number,
    content: {
        text?: string,
        picUrl?: string,
        title?: string,
        url?: string,
        videoUrl?: string
    },
}

interface QueryParams {
    taskId: string,
    auth: AuthContextValue
    msg?: string
}

export const queryMomentsList = async ({ publishStatus, auth }: QueryMomentsListParams) => {
    const { corpId, userId } = auth;
    const res = await axios.get<MomentsListResult[]>(`${API_PREFIX.WEB}/moment/queryMomentListToWork`, {
        params: { publishStatus, corpId, userId }
    });
    return res.data;
}

export const queryTaskStatus = async ({taskId, auth}: QueryParams )=>{
    const { corpId, userId } = auth;
    const res = await axios.get<number>(`${API_PREFIX.WEB}/moment/queryPublishStatus`,{
        params: {taskId, corpId, userId}
    })
    return res.data;
}

export const queryMediaInfo = async ({taskId, auth}: QueryParams) => {
    const { corpId, userId } = auth;
    const res = await axios.get(`${API_PREFIX.WEB}/moment/queryMediaInfo`,{
        params: {taskId, corpId, userId}
    })
    return res.data;
}

export const logMoment = async ({ taskId, auth, msg }: QueryParams) => {
    const { corpId, userId } = auth;
    const res = await axios.get(`${API_PREFIX.WEB}/moment/momentLog`,{
        params: { taskId, corpId, userId, msg }
    })
    return res.data;
}

export const queryMomentsSummary = async (auth: AuthContextValue) => {
    const { corpId, userId } = auth;
    const res = await axios.get(`${API_PREFIX.WEB}/moment/queryPublishStatusStat`,{
        params: {corpId, userId}
    })
    return res.data;
}

export const executeFinish = async ({taskId, auth}: QueryParams) => {
    const { corpId, userId } = auth;
    await axios.get(`${API_PREFIX.WEB}/moment/executeFinish`,{
        params: {taskId, corpId, userId}
    })
}
